import { useCallback, useReducer, useContext } from 'react';
import { SlykitContext } from '../slykitContext';
import produce, { Draft } from 'immer';

export function useApplicationState(toCheck = {} as TODO) {
	const init = useCallback(
		(passedInState) => {
			if (toCheck && toCheck.savedStates) {
				if (toCheck.savedStates.dashboards) {
					passedInState.savedStates.dashboards = toCheck.savedStates.dashboards;
				}

				if (toCheck.savedStates.widgets) {
					passedInState.savedStates.widgets = toCheck.savedStates.widgets;
				}
			}
			if (toCheck && toCheck.features) {
				for (const [key, value] of Object.entries(toCheck.features)) {
					if (Object.keys(passedInState.features).includes(key)) {
						passedInState.features[key] = value;
					} else { 
						console.warn(
							'SERBERUS: There is no feature ' + key + ' expected in the IApplication Interface. Change or remove this feature or add it to the interface.'
						);
					}
				}
				passedInState.features = toCheck.features;
			}
			return passedInState;
		},
		[toCheck]
	);

	const [state, dispatch] = useReducer(reducer, initialState, init);
	return [state, dispatch];
}

const reducer = produce((draft: Draft<IApplicationState>, action) => {
	switch (action.type) {
		case ApplicationStateActions.UPDATE_DASHBOARD: {
			const { key, dashboard } = action.payload;
			draft.savedStates.dashboards[key] = dashboard;
			break;
		}
		case ApplicationStateActions.UPDATE_WIDGET: {
			const { key, widget } = action.payload;
			draft.savedStates.widgets[key] = widget;
			break;
		}
		case ApplicationStateActions.UPDATE_WIDGETS: {
			draft.savedStates.widgets = action.payload
			break;
		  }
		case ApplicationStateActions.UPDATE_APP_STATE: {
			draft.savedStates = action.payload.savedStates;
			break;
		}
		case ApplicationStateActions.UPDATE_FEATURES: {
			for (const [key, value] of Object.entries(action.payload)) {
				if (Object.keys(draft.features).includes(key)) {
					draft.features[key] = value;
				}
			}
			break;
		}
		default:
			break;
	}
});
type TODO = any;

export interface IApplicationState {
	savedStates: {
		dashboards: TODO;
		widgets: TODO;
	};
	features: IFeatures;
}
export interface IFeatures {
	isSaveViewsEnabled: boolean;
}

let initialState: IApplicationState = {
	savedStates: {
		dashboards: {},
		widgets: {},
	},
	features: {
		isSaveViewsEnabled: false,
	},
};

export const ApplicationStateActions = {
	UPDATE_DASHBOARD: 'UPDATE_DASHBOARD',
	UPDATE_WIDGET: 'UPDATE_WIDGET',
	UPDATE_WIDGETS: 'UPDATE_WIDGETS',
	UPDATE_APP_STATE: 'UPDATE_APP_STATE',
	UPDATE_FEATURES: 'UPDATE_FEATURES',
};

export const ApplicationStateActionCreator = {
	updateDashboard: (key, dashboard) => ({
		type: ApplicationStateActions.UPDATE_DASHBOARD,
		payload: {
			key,
			dashboard,
		},
	}),
	updateAppState: (payload) => ({
		type: ApplicationStateActions.UPDATE_APP_STATE,
		payload: payload,
	}),
	updateFeatures: (payload) => ({
		type: ApplicationStateActions.UPDATE_FEATURES,
		payload: payload,
	}),
	updateWidgets: (payload) => ({
		type: ApplicationStateActions.UPDATE_WIDGETS,
		payload: payload
	  })
};

// Boolean to see if Saved States is enabled
export function useIsSavedStateAvailable(): boolean {
	const context = useContext(SlykitContext);
	return context?.state?.features.isSaveViewsEnabled;
}
